import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Typography, Box, Tabs, Tab } from "@mui/material";
import ContactsTab from "./ContactsTab";
import AddressesTab from "./AddressesTab";
import AccountNotesTab from "./AccountNotesTab";
import ThemedTabs from "../components/ThemedTabs";
import { DARK_THEME_INPUT_OUTLINE_COLOR } from "../constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ClientInformationTabs = ({
  includeAccountNotesTab = true,
  account_id,
  canDelete,
  border = false,
}) => {
  const [value, setValue] = useState(0);
  const project = useSelector((state) => state.project);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%", height: 458 }}>
        <Box
          sx={{
            borderColor: "divider",
            borderTop: border
              ? `1px solid ${DARK_THEME_INPUT_OUTLINE_COLOR}`
              : "none",
            borderLeft: border
              ? `1px solid ${DARK_THEME_INPUT_OUTLINE_COLOR}`
              : "none",
            borderRight: border
              ? `1px solid ${DARK_THEME_INPUT_OUTLINE_COLOR}`
              : "none",
          }}
        >
          <ThemedTabs
            value={value}
            onChange={handleChange}
            labels={
              includeAccountNotesTab
                ? ["Contacts", "Addresses", "Account Notes"]
                : ["Contacts", "Addresses"]
            }
            variant="fullWidth"
            aria-label="project-details-tab"
          />
        </Box>
        <TabPanel value={value} index={0}>
          <ContactsTab
            value={value}
            index={0}
            account_id={account_id}
            canDelete={canDelete}
            border={border}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddressesTab
            value={value}
            index={1}
            account_id={account_id}
            canDelete={canDelete}
            border={border}
          />
        </TabPanel>
        {includeAccountNotesTab ? (
          <TabPanel value={value} index={2}>
            <AccountNotesTab border={border} />
          </TabPanel>
        ) : null}
      </Box>
    </>
  );
};

export default ClientInformationTabs;
